import React from 'react';
import moment from "moment";
import { AppContext } from "../utils/context";

class Clock extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            serverTime: ''
        };
    }

    componentDidMount() {
        this.tick();
        this.intervalID = setInterval(
            () => this.tick(),
            1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.intervalID);
    }

    tick() {
        if (this.context && this.context.config && this.context.config.time_zone_offset) {
            this.setState({
                serverTime: moment().utcOffset(this.context.config.time_zone_offset).format('h:mm:ss A')
            });
        }
    }

    render() {
        return (
            <p>
                {this.state.serverTime}
            </p>
        );
    }
}
Clock.contextType = AppContext;

export default Clock;
